
  .responsive3208187990__root .InfoIcon3678204901__root:focus {
    outline: 2px solid #7cafff;
  }

  .responsive3208187990__root .InfoIcon3678204901__root.InfoIcon3678204901---icon-4-info {
    color: #595d70;
  }

  .responsive3208187990__root .InfoIcon3678204901__root.InfoIcon3678204901---icon-5-error {
    color: #ee4437;
  }

  .responsive3208187990__root .InfoIcon3678204901__root[disabled] {
    color: #bebebe;
  }

  .responsive3208187990__root .InfoIcon3678204901__root:not([disabled]).InfoIcon3678204901---icon-4-info:hover,
  .responsive3208187990__root .InfoIcon3678204901__root:not([disabled]).InfoIcon3678204901---icon-4-info:focus {
    color: #116dff;
  }

/* st-namespace-reference="../../../../src/atoms/InfoIcon/InfoIcon.responsive.st.css" */